import { z } from 'zod'
import { Model } from './architecture'

export const ImageCategoryOrderValidation = z.object({
  value: z.number({ required_error: '[ImageCategory] value is required' }).positive(),
})

export class ImageCategoryOrder extends Model {
  static create({ value }: z.infer<typeof ImageCategoryOrderValidation>) {
    ImageCategoryOrderValidation.parse({ value })
    return new ImageCategoryOrder(value)
  }

  static empty() {
    return new ImageCategoryOrder(0)
  }

  constructor(private readonly _value: number) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
